import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2d5d1e2b = () => interopDefault(import('../../../pages/1800accountant.vue' /* webpackChunkName: "pages/1800accountant" */))
const _7311cc54 = () => interopDefault(import('../../../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _bc4e4c68 = () => interopDefault(import('../../../pages/about/index/index.ts' /* webpackChunkName: "pages/about/index/index" */))
const _207e38a0 = () => interopDefault(import('../../../pages/about/index/benefits.ts' /* webpackChunkName: "pages/about/index/benefits" */))
const _3a4ec730 = () => interopDefault(import('../../../pages/about/index/culture.ts' /* webpackChunkName: "pages/about/index/culture" */))
const _aeedca96 = () => interopDefault(import('../../../pages/about/index/hr-managers.ts' /* webpackChunkName: "pages/about/index/hr-managers" */))
const _f153eaba = () => interopDefault(import('../../../pages/about/index/investors.ts' /* webpackChunkName: "pages/about/index/investors" */))
const _d57ce792 = () => interopDefault(import('../../../pages/about/index/leadership.ts' /* webpackChunkName: "pages/about/index/leadership" */))
const _37bd9e68 = () => interopDefault(import('../../../pages/about/index/teams.ts' /* webpackChunkName: "pages/about/index/teams" */))
const _0f24e6a7 = () => interopDefault(import('../../../pages/avibra.vue' /* webpackChunkName: "pages/avibra" */))
const _12fd61ef = () => interopDefault(import('../../../pages/berkley-select.vue' /* webpackChunkName: "pages/berkley-select" */))
const _0faef30f = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _3325ea70 = () => interopDefault(import('../../../pages/compliance/index.vue' /* webpackChunkName: "pages/compliance/index" */))
const _97982dfc = () => interopDefault(import('../../../pages/constantcontact.vue' /* webpackChunkName: "pages/constantcontact" */))
const _d93727c8 = () => interopDefault(import('../../../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _49dd5a8f = () => interopDefault(import('../../../pages/fo-agency.vue' /* webpackChunkName: "pages/fo-agency" */))
const _6338b142 = () => interopDefault(import('../../../pages/free-trial.vue' /* webpackChunkName: "pages/free-trial" */))
const _5c6fc8be = () => interopDefault(import('../../../pages/handbooks.vue' /* webpackChunkName: "pages/handbooks" */))
const _dd3bfd6a = () => interopDefault(import('../../../pages/hello-alice.vue' /* webpackChunkName: "pages/hello-alice" */))
const _72afd448 = () => interopDefault(import('../../../pages/help-scout.vue' /* webpackChunkName: "pages/help-scout" */))
const _534f9b74 = () => interopDefault(import('../../../pages/hr.vue' /* webpackChunkName: "pages/hr" */))
const _d8b0218e = () => interopDefault(import('../../../pages/hr-policies.vue' /* webpackChunkName: "pages/hr-policies" */))
const _798def2e = () => interopDefault(import('../../../pages/industries/index.vue' /* webpackChunkName: "pages/industries/index" */))
const _cf668940 = () => interopDefault(import('../../../pages/insurance.vue' /* webpackChunkName: "pages/insurance" */))
const _e4389118 = () => interopDefault(import('../../../pages/jpmorgan.vue' /* webpackChunkName: "pages/jpmorgan" */))
const _75fbe610 = () => interopDefault(import('../../../pages/labor-laws.vue' /* webpackChunkName: "pages/labor-laws" */))
const _d9415bfc = () => interopDefault(import('../../../pages/legal/index.vue' /* webpackChunkName: "pages/legal/index" */))
const _c6103bf6 = () => interopDefault(import('../../../pages/onboarding.vue' /* webpackChunkName: "pages/onboarding" */))
const _7d37a5d6 = () => interopDefault(import('../../../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _f0f2d3e6 = () => interopDefault(import('../../../pages/partnership/index.vue' /* webpackChunkName: "pages/partnership/index" */))
const _a9cc1fc0 = () => interopDefault(import('../../../pages/peo.vue' /* webpackChunkName: "pages/peo" */))
const _a6289b16 = () => interopDefault(import('../../../pages/product.vue' /* webpackChunkName: "pages/product" */))
const _18ad51fe = () => interopDefault(import('../../../pages/radio.vue' /* webpackChunkName: "pages/radio" */))
const _425ea923 = () => interopDefault(import('../../../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _0eebbbb1 = () => interopDefault(import('../../../pages/registration/_slug.js' /* webpackChunkName: "pages/registration/_slug" */))
const _57ee63a1 = () => interopDefault(import('../../../pages/reviews.vue' /* webpackChunkName: "pages/reviews" */))
const _00d8ed07 = () => interopDefault(import('../../../pages/square.vue' /* webpackChunkName: "pages/square" */))
const _37474f59 = () => interopDefault(import('../../../pages/terminations.vue' /* webpackChunkName: "pages/terminations" */))
const _10b46c78 = () => interopDefault(import('../../../pages/training.vue' /* webpackChunkName: "pages/training" */))
const _680220ec = () => interopDefault(import('../../../pages/tv.vue' /* webpackChunkName: "pages/tv" */))
const _93507240 = () => interopDefault(import('../../../pages/articles/preview.vue' /* webpackChunkName: "pages/articles/preview" */))
const _66944837 = () => interopDefault(import('../../../pages/checkout/wvpp.ts' /* webpackChunkName: "pages/checkout/wvpp" */))
const _3240f5a2 = () => interopDefault(import('../../../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _0df851c7 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _0d245ffa = () => interopDefault(import('../../../pages/compliance/_slug/index.vue' /* webpackChunkName: "pages/compliance/_slug/index" */))
const _c1595e38 = () => interopDefault(import('../../../pages/industries/_slug/index.vue' /* webpackChunkName: "pages/industries/_slug/index" */))
const _dcae9e8c = () => interopDefault(import('../../../pages/legal/_slug.vue' /* webpackChunkName: "pages/legal/_slug" */))
const _90904446 = () => interopDefault(import('../../../pages/partnership/_brand.vue' /* webpackChunkName: "pages/partnership/_brand" */))
const _b186cf36 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/1800accountant",
    component: _2d5d1e2b,
    name: "1800accountant"
  }, {
    path: "/about",
    component: _7311cc54,
    children: [{
      path: "",
      component: _bc4e4c68,
      name: "about-index"
    }, {
      path: "benefits",
      component: _207e38a0,
      name: "about-index-benefits"
    }, {
      path: "culture",
      component: _3a4ec730,
      name: "about-index-culture"
    }, {
      path: "hr-managers",
      component: _aeedca96,
      name: "about-index-hr-managers"
    }, {
      path: "investors",
      component: _f153eaba,
      name: "about-index-investors"
    }, {
      path: "leadership",
      component: _d57ce792,
      name: "about-index-leadership"
    }, {
      path: "teams",
      component: _37bd9e68,
      name: "about-index-teams"
    }]
  }, {
    path: "/avibra",
    component: _0f24e6a7,
    name: "avibra"
  }, {
    path: "/berkley-select",
    component: _12fd61ef,
    name: "berkley-select"
  }, {
    path: "/blog",
    component: _0faef30f,
    name: "blog"
  }, {
    path: "/compliance",
    component: _3325ea70,
    name: "compliance"
  }, {
    path: "/constantcontact",
    component: _97982dfc,
    name: "constantcontact"
  }, {
    path: "/faq",
    component: _d93727c8,
    name: "faq"
  }, {
    path: "/fo-agency",
    component: _49dd5a8f,
    name: "fo-agency"
  }, {
    path: "/free-trial",
    component: _6338b142,
    name: "free-trial"
  }, {
    path: "/handbooks",
    component: _5c6fc8be,
    name: "handbooks"
  }, {
    path: "/hello-alice",
    component: _dd3bfd6a,
    name: "hello-alice"
  }, {
    path: "/help-scout",
    component: _72afd448,
    name: "help-scout"
  }, {
    path: "/hr",
    component: _534f9b74,
    name: "hr"
  }, {
    path: "/hr-policies",
    component: _d8b0218e,
    name: "hr-policies"
  }, {
    path: "/industries",
    component: _798def2e,
    name: "industries"
  }, {
    path: "/insurance",
    component: _cf668940,
    name: "insurance"
  }, {
    path: "/jpmorgan",
    component: _e4389118,
    name: "jpmorgan"
  }, {
    path: "/labor-laws",
    component: _75fbe610,
    name: "labor-laws"
  }, {
    path: "/legal",
    component: _d9415bfc,
    name: "legal"
  }, {
    path: "/onboarding",
    component: _c6103bf6,
    name: "onboarding"
  }, {
    path: "/partners",
    component: _7d37a5d6,
    name: "partners"
  }, {
    path: "/partnership",
    component: _f0f2d3e6,
    name: "partnership"
  }, {
    path: "/peo",
    component: _a9cc1fc0,
    name: "peo"
  }, {
    path: "/product",
    component: _a6289b16,
    name: "product"
  }, {
    path: "/radio",
    component: _18ad51fe,
    name: "radio"
  }, {
    path: "/registration",
    component: _425ea923,
    name: "registration",
    children: [{
      path: ":slug?",
      component: _0eebbbb1,
      name: "registration-slug"
    }]
  }, {
    path: "/reviews",
    component: _57ee63a1,
    name: "reviews"
  }, {
    path: "/square",
    component: _00d8ed07,
    name: "square"
  }, {
    path: "/terminations",
    component: _37474f59,
    name: "terminations"
  }, {
    path: "/training",
    component: _10b46c78,
    name: "training"
  }, {
    path: "/tv",
    component: _680220ec,
    name: "tv"
  }, {
    path: "/articles/preview",
    component: _93507240,
    name: "articles-preview"
  }, {
    path: "/checkout/wvpp",
    component: _66944837,
    name: "checkout-wvpp"
  }, {
    path: "/articles/:slug?",
    component: _3240f5a2,
    name: "articles-slug"
  }, {
    path: "/blog/:slug",
    component: _0df851c7,
    name: "blog-slug"
  }, {
    path: "/compliance/:slug",
    component: _0d245ffa,
    name: "compliance-slug"
  }, {
    path: "/industries/:slug",
    component: _c1595e38,
    name: "industries-slug"
  }, {
    path: "/legal/:slug",
    component: _dcae9e8c,
    name: "legal-slug"
  }, {
    path: "/partnership/:brand",
    component: _90904446,
    name: "partnership-brand"
  }, {
    path: "/*",
    component: _b186cf36,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
